/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:34
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-11 15:01:28
 */
/* eslint-disable react/display-name */
import { Popover, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { QuestionCircleTwoTone } from '@ant-design/icons'
import { getXianzhonglxName } from '../../models/AnnualCapitalFund'
import { DateTimeFormat, DateTimeFormatSimpleOnly } from '../../models/datetime'
import { Dimen } from '../../models/dimen'

const HeadTips: Record<string, string> = {
  headCount: '统计周期内，不同的参保患者人数（同一个人多次就诊只算 1 人）',
  personTime: '统计周期内，门诊结算就诊的总次数（同一患者多次来院，每次都累加）',
  personHeadScale: '平均每位患者就诊的频次 = 人次数 / 人头数',
  totalAmount: '患者本次结算医保目录内所有项目费用合计，不含目录外自费项目',
  includedMedicalExpenses:
    '纳入统筹基金报销的金额，= 总费用 - 乙类先行自费 - 丙类全自费 - 超限价自费',
  selfpayAmt: '在医保报销范围内、需个人按比例承担的费用',
  cashAmount: '不在医保报销范围内、需要患者全额自己掏钱的费用',
  includedMedicalExpensesPer: '单次就诊平均医保报销金额，= 列支金额 / 就诊人次数',
  includedMedicalExpensesPerson: '每个参保患者平均享受到的医保报销金额，= 列支总额 / 人头数',
}

// 表头带问号提示：文字宽度不足时省略，但提示图标始终保留
const HeadTip = (
  title: string,
  tip: string,
  align: 'center' | 'right' = 'center',
): ReactElement => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: align === 'right' ? 'flex-end' : 'center',
    }}
  >
    <span
      style={{
        flex: '0 1 auto',
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {title}
    </span>
    <Popover
      content={<div style={{ width: '375px' }}>{tip}</div>}
      placement='top'
      title='说明'
    >
      <QuestionCircleTwoTone style={{ marginLeft: 4 }} />
    </Popover>
  </div>
)

export const Column = (): TableColumnType<any>[] => {
  return [
    {
      title: '时间',
      key: 'no',
      align: 'center',
      width: '11em',
      ellipsis: true,
      fixed: 'left',
      render: function element(_, t) {
        return (
          <div>
            {moment(t?.startTime)?.format(DateTimeFormatSimpleOnly)} ~
            {moment(t?.endTime)?.format(DateTimeFormatSimpleOnly)}
          </div>
        )
      },
    },
    {
      title: HeadTip('人头数', HeadTips.headCount),
      dataIndex: 'headCount',
      width: '5em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.headCount ? r?.headCount : 0
      },
    },
    {
      title: HeadTip('人次数', HeadTips.personTime),
      dataIndex: 'personTime',
      width: '5em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.personTime ? r?.personTime : 0
      },
    },
    {
      title: HeadTip('人次人头比', HeadTips.personHeadScale),
      dataIndex: 'personHeadScale',
      width: '6em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.personHeadScale ? r?.personHeadScale : 0
      },
    },
    {
      title: HeadTip('医疗费总金额（元）', HeadTips.totalAmount, 'right'),
      key: 'totalAmount',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.totalAmount) > 0
                  ? Number(t?.totalAmount)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
    {
      title: HeadTip('列支金额（元）', HeadTips.includedMedicalExpenses, 'right'),
      key: 'includedMedicalExpenses',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.includedMedicalExpenses) > 0
                  ? Number(t?.includedMedicalExpenses)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
    {
      title: HeadTip('自理金额（元）', HeadTips.selfpayAmt, 'right'),
      dataIndex: 'selfpayAmt',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return Number(t?.selfpayAmt) > 0
            ? Number(t?.selfpayAmt)?.toFixed(2)
            : '0.00'
      },
    },
    {
      title: HeadTip('自费金额（元）', HeadTips.cashAmount, 'right'),
      dataIndex: 'cashAmount',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return Number(t?.cashAmount) > 0
            ? Number(t?.cashAmount)?.toFixed(2)
            : '0.00'
      },
    },
    {
      title: HeadTip('次均列支（元）', HeadTips.includedMedicalExpensesPer, 'right'),
      key: 'includedMedicalExpensesPer',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.includedMedicalExpensesPer) > 0
                  ? Number(t?.includedMedicalExpensesPer)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
    {
      title: HeadTip('人均列支（元）', HeadTips.includedMedicalExpensesPerson, 'right'),
      key: 'includedMedicalExpensesPerson',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.includedMedicalExpensesPerson) > 0
                  ? Number(t?.includedMedicalExpensesPerson)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
  ]
}


export const Columns = (v?:any): TableColumnType<any>[] => {
  return [
    {
      title: '时间',
      key: 'no',
      align: 'center',
      width: '11em',
      ellipsis: true,
      fixed: 'left',
      render: function element(_, t) {
        return (
          <div>
            {moment(v?.startTime)
              ?.subtract(1, 'year')
              ?.format(DateTimeFormatSimpleOnly)}
            ~
            {moment(v?.endTime)
              ?.subtract(1, 'year')
              ?.format(DateTimeFormatSimpleOnly)}
          </div>
        )
      },
    },
    {
      title: '人头数',
      dataIndex: 'headCount',
      width: '5em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.headCount ? r?.headCount : 0
      },
    },
    {
      title: '人次数',
      dataIndex: 'personTime',
      width: '5em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.personTime ? r?.personTime : 0
      },
    },
    {
      title: '人次人头比',
      dataIndex: 'personHeadScale',
      width: '6em',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return r?.personHeadScale ? r?.personHeadScale : 0
      },
    },
    {
      title: '医疗费总金额（元）',
      key: 'totalAmount',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <div>
            {Number(t?.totalAmount) > 0
              ? Number(t?.totalAmount)?.toFixed(2)
              : '0.00'}
          </div>
        )
      },
    },
    {
      title: '列支金额（元）',
      key: 'includedMedicalExpenses',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.includedMedicalExpenses) > 0
                  ? Number(t?.includedMedicalExpenses)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
    {
      title: '自理金额（元）',
      dataIndex: 'selfpayAmt',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return Number(t?.selfpayAmt) > 0
          ? Number(t?.selfpayAmt)?.toFixed(2)
          : '0.00'
      },
    },
    {
      title: '自费金额（元）',
      dataIndex: 'cashAmount',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return Number(t?.cashAmount) > 0
          ? Number(t?.cashAmount)?.toFixed(2)
          : '0.00'
      },
    },
    {
      title: '次均列支（元）',
      key: 'includedMedicalExpensesPer',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.includedMedicalExpensesPer) > 0
                  ? Number(t?.includedMedicalExpensesPer)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
    {
      title: '人均列支（元）',
      key: 'includedMedicalExpensesPerson',
      width: '8em',
      align: 'right',
      ellipsis: true,
      render: function element(_, t) {
        return (
            <div>
              {Number(t?.includedMedicalExpensesPerson) > 0
                  ? Number(t?.includedMedicalExpensesPerson)?.toFixed(2)
                  : '0.00'}
            </div>
        )
      },
    },
  ]
}
